import { configureStore } from '@reduxjs/toolkit';

import { InitialState as ConfigState } from './configStore';
import { InitialState as NavigationState } from './navigationStore';
import { InitialState as FetchState } from "./fetchActionStore";
import { InitialState as PaginationState } from "./paginationStore";
import { InitialState as TeamsState }  from "./teamsStore";
import { InitialState as NewsRoomState } from "./newsroomStore";
import { InitialState as ScheduleStat } from "./scheduleStore";
import { InitialState as ArticleState } from "./ArticleStore";

import configStore  from "./configStore";
import navigationStore from "./navigationStore";
import fetchDataStore from "./fetchActionStore";
import paginationStore from "./paginationStore";
import teamsStore from "./teamsStore";
import newsroomStore from "./newsroomStore";
import scheduleStore from "./scheduleStore";
import articleStore from "./ArticleStore";

export type RootState = {
  config: ConfigState;
  navigation: NavigationState;
  fetchData: FetchState;
  pagination: PaginationState;
  teams: TeamsState;
  newsroom: NewsRoomState;
  schedule: ScheduleStat;
  articleStore: ArticleState;
};

const store = configureStore({
  reducer: {
    config: configStore,
    navigation: navigationStore,
    fetchData: fetchDataStore as any,
    pagination: paginationStore,
    teams: teamsStore,
    newsroom: newsroomStore,
    articleStore: articleStore,
    schedule: scheduleStore as any,
  },
  middleware: (getDefaultMiddleware
  ) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }),
});

export type AppDispatch = typeof store.dispatch;

export default store;